// eslint-disable-next-line you-dont-need-lodash-underscore/concat
import { concat, differenceBy } from 'lodash';

import { READING_ACTION_TYPES, ACTIVITY_ACTION_TYPES, EVIDENCE_TAGGING_ACTION_TYPES } from '../actions/action_types';
import { findAnsweredActivities, isInlineActivityAnswered } from '../../services/activities';

export const initialState = {
  activity: null,
  answeredActivity: null,
  currentActivityId: null,
  currentActivityPage: null,
  visibleActivities: [],
  chapterActivities: [],
  seenActivities: [],
  answeredActivities: [],
  all: {},
  currentActivityOrder: -1,
  activityPositions: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case READING_ACTION_TYPES.SET_BOOK_STATE: {
      const { activityAnswers, evidenceTaggingAnswers } = payload;
      const answeredActivities = concat(activityAnswers, evidenceTaggingAnswers);
      return { ...state, answeredActivities };
    }
    case ACTIVITY_ACTION_TYPES.SET_ACTIVITIES: {
      const all = {};
      payload.forEach((activity, index) => {
        all[activity.activityId] = { ...activity, questionIndex: index, order: index };
      });
      return { ...state, all };
    }
    case ACTIVITY_ACTION_TYPES.SET_CHAPTER_ACTIVITIES: {
      const allActivities = state.all;
      payload.forEach((activity, index) => {
        if (allActivities[activity]) {
          allActivities[activity].order = index;
        }
      });
      return { ...state, chapterActivities: payload, all: allActivities };
    }
    case ACTIVITY_ACTION_TYPES.ANSWER:
    case EVIDENCE_TAGGING_ACTION_TYPES.ANSWER: {
      const answeredActivity = payload;
      const { correct, attempts, activityId, selectedAnswerId } = answeredActivity;
      const visibleActivities = [...state.visibleActivities];
      const answeredActivities = [...state.answeredActivities];

      answeredActivities.push({
        activityId,
        correct,
        attempts,
        selectedAnswerId,
      });

      const completedActivities = findAnsweredActivities(state.all, answeredActivities);
      const activitiesToShow = differenceBy(visibleActivities, completedActivities, 'activityId');

      let result = { answeredActivities, visibleActivities: activitiesToShow, answeredActivity };

      if (correct) {
        result = { ...result, answeredActivity };
      }

      return { ...state, ...result };
    }

    case ACTIVITY_ACTION_TYPES.SET_VISIBLE_ACTIVITIES: {
      const { visibleActivities } = payload;
      const answeredActivities = findAnsweredActivities(state.all, state.answeredActivities);

      const activitiesToShow = differenceBy(visibleActivities, answeredActivities, 'activityId');
      return { ...state, visibleActivities: activitiesToShow };
    }

    case ACTIVITY_ACTION_TYPES.SET_CURRENT_ACTIVITY: {
      const { activityId, currentPage, order } = payload;
      const seen = activityId === null
        ? state.seenActivities
        : [...state.seenActivities, activityId];
      const seenActivities = new Set(seen);

      return {
        ...state,
        currentActivityId: activityId,
        currentActivityPage: currentPage,
        seenActivities,
        currentActivityOrder: order,
      };
    }

    case READING_ACTION_TYPES.SHOW_UNANSWERED_QUESTIONS: {
      const { all, answeredActivities } = state;

      return {
        ...state,
        answeredActivities: answeredActivities.filter((answer) => {
          const activity = all?.[answer.activityId] || {};

          return isInlineActivityAnswered({ ...answer, activityType: activity.activityType });
        }),
      };
    }

    case ACTIVITY_ACTION_TYPES.SET_ACTIVITY_ORDER: {
      return {
        ...state,
        order: payload,
      };
    }

    case ACTIVITY_ACTION_TYPES.SET_ACTIVITY_POSITIONS: {
      return {
        ...state,
        activityPositions: payload,
      };
    }

    case READING_ACTION_TYPES.CLOSE_BOOK:
      return initialState;

    default:
      return state;
  }
};
